 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import PRAISE_FOR_KATE_GRENVILLE from '@/components/Praise_For_Kate_Grenville'
 import PRAISE_FOR_KATE_GRENVILLE1 from '@/components/Praise_For_Kate_Grenville1'
 import ALSO_BY from '@/components/also_by'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import OTHER from '@/components/other'
 import PART_1 from '@/components/part_1'
 import A780802194459_CH01 from '@/components/9780802194459_ch01'
 import A780802194459_CH02 from '@/components/9780802194459_ch02'
 import A780802194459_CH03 from '@/components/9780802194459_ch03'
 import A780802194459_CH04 from '@/components/9780802194459_ch04'
 import A780802194459_CH05 from '@/components/9780802194459_ch05'
 import A780802194459_CH06 from '@/components/9780802194459_ch06'
 import A780802194459_CH07 from '@/components/9780802194459_ch07'
 import A780802194459_CH08 from '@/components/9780802194459_ch08'
 import A780802194459_CH09 from '@/components/9780802194459_ch09'
 import A780802194459_CH10 from '@/components/9780802194459_ch10'
 import A780802194459_CH11 from '@/components/9780802194459_ch11'
 import PART_2 from '@/components/part_2'
 import A780802194459_CH12 from '@/components/9780802194459_ch12'
 import A780802194459_CH13 from '@/components/9780802194459_ch13'
 import A780802194459_CH14 from '@/components/9780802194459_ch14'
 import A780802194459_CH15 from '@/components/9780802194459_ch15'
 import A780802194459_CH16 from '@/components/9780802194459_ch16'
 import A780802194459_CH17 from '@/components/9780802194459_ch17'
 import PART_3 from '@/components/part_3'
 import A780802194459_CH18 from '@/components/9780802194459_ch18'
 import A780802194459_CH19 from '@/components/9780802194459_ch19'
 import A780802194459_CH20 from '@/components/9780802194459_ch20'
 import A780802194459_CH21 from '@/components/9780802194459_ch21'
 import A780802194459_CH22 from '@/components/9780802194459_ch22'
 import A780802194459_CH23 from '@/components/9780802194459_ch23'
 import A780802194459_CH24 from '@/components/9780802194459_ch24'
 import A780802194459_CH25 from '@/components/9780802194459_ch25'
 import A780802194459_CH26 from '@/components/9780802194459_ch26'
 import A780802194459_CH27 from '@/components/9780802194459_ch27'
 import A780802194459_CH28 from '@/components/9780802194459_ch28'
 import A780802194459_CH29 from '@/components/9780802194459_ch29'
 import A780802194459_CH30 from '@/components/9780802194459_ch30'
 import A780802194459_CH31 from '@/components/9780802194459_ch31'
 import PART_4 from '@/components/part_4'
 import A780802194459_CH32 from '@/components/9780802194459_ch32'
 import A780802194459_CH33 from '@/components/9780802194459_ch33'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/Praise_For_Kate_Grenville",
 			"name" : "Praise_For_Kate_Grenville",
 			"component" : PRAISE_FOR_KATE_GRENVILLE
 		},
 		{
 			"path" : "/Praise_For_Kate_Grenville1",
 			"name" : "Praise_For_Kate_Grenville1",
 			"component" : PRAISE_FOR_KATE_GRENVILLE1
 		},
 		{
 			"path" : "/also_by",
 			"name" : "also_by",
 			"component" : ALSO_BY
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/other",
 			"name" : "other",
 			"component" : OTHER
 		},
 		{
 			"path" : "/part_1",
 			"name" : "part_1",
 			"component" : PART_1
 		},
 		{
 			"path" : "/9780802194459_ch01",
 			"name" : "9780802194459_ch01",
 			"component" : A780802194459_CH01
 		},
 		{
 			"path" : "/9780802194459_ch02",
 			"name" : "9780802194459_ch02",
 			"component" : A780802194459_CH02
 		},
 		{
 			"path" : "/9780802194459_ch03",
 			"name" : "9780802194459_ch03",
 			"component" : A780802194459_CH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js